import React from 'react'
import PropTypes from 'prop-types'

import { UploadButtons } from '../../UploadButtons'

export default function EmptyCard({
  aspectRatio = '9:16',
  onDeviceUpload,
  onLibraryUpload,
  disabled = false,
}) {
  return (
    <div className='empty-card'>
      <UploadButtons
        hasMedia={false}
        onDeviceUpload={onDeviceUpload}
        onLibraryUpload={onLibraryUpload}
        disabled={disabled}
        showLimitInfoBox={false}
      />

      <p className='aspect-ratio'>{aspectRatio}</p>
    </div>
  )
}

EmptyCard.propTypes = {
  aspectRatio: PropTypes.string,
  onDeviceUpload: PropTypes.func,
  onLibraryUpload: PropTypes.func,
  disabled: PropTypes.bool,
}